module.exports = __webpack_public_path__ + "img/nosotros_16-9.bf031601.jpg";